
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class BookedEntryModel extends Model<BookedEntryModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'entryNumber', type: 'number' },
		{ name: 'accountNumber', type: 'number' },
		{ name: 'projectNumber', type: 'number' },
		{ name: 'amount', type: 'number' },
		{ name: 'amountInBaseCurrency', type: 'number' },
		{ name: 'currencyCode', type: 'string' },
		{ name: 'date', type: 'Date' },
		{ name: 'dueDate', type: 'Date' },
		{ name: 'text', type: 'string' },
		{ name: 'type', type: 'EntryTypeNames' },
		{ name: 'vatAccountNumber', type: 'string' },
		{ name: 'voucherNumber', type: 'number' },
		{ name: 'customerNumber', type: 'number' },
		{ name: 'customerInvoiceNumber', type: 'number' },
		{ name: 'supplierNumber', type: 'number' },
		{ name: 'supplierInvoiceNumber', type: 'string' },
		{ name: 'remainder', type: 'number' },
		{ name: 'objectVersion', type: 'string' },
		{ name: 'amountInclVat', type: 'number' },
		{ name: 'amountExclVat', type: 'number' }
	];
	[key: string]: any;
	
	public entryNumber: number;
	public accountNumber: number;
	public projectNumber?: number;
	public amount?: number;
	public amountInBaseCurrency?: number;
	public currencyCode: string;
	public date?: Date;
	public dueDate?: Date;
	public text: string;
	public type?: EntryTypeNames;
	public vatAccountNumber: string;
	public voucherNumber?: number;
	public customerNumber?: number;
	public customerInvoiceNumber?: number;
	public supplierNumber?: number;
	public supplierInvoiceNumber: string;
	public remainder?: number;
	public objectVersion: string;
	public amountInclVat: number;
	public amountExclVat: number;
    
	constructor(){
		super();
		this.entryNumber = 0;
		this.accountNumber = 0;
		this.projectNumber = undefined;
		this.amount = undefined;
		this.amountInBaseCurrency = undefined;
		this.currencyCode = '';
		this.date = undefined;
		this.dueDate = undefined;
		this.text = '';
		this.type = undefined;
		this.vatAccountNumber = '';
		this.voucherNumber = undefined;
		this.customerNumber = undefined;
		this.customerInvoiceNumber = undefined;
		this.supplierNumber = undefined;
		this.supplierInvoiceNumber = '';
		this.remainder = undefined;
		this.objectVersion = '';
		this.amountInclVat = 0;
		this.amountExclVat = 0;
		
	}
	getProperties(){
		return BookedEntryModel.classProperties;
	}
}
export class BookedEntryCursorResultsModel extends Model<BookedEntryCursorResultsModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'cursor', type: 'string' },
		{ name: 'items', type: 'BookedEntryModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new BookedEntryModel }, properties: () => { return BookedEntryModel.classProperties } }
	];
	[key: string]: any;
	
	public cursor: string;
	public items: BookedEntryModel[];
    
	constructor(){
		super();
		this.cursor = '';
		this.items = [];
		
	}
	getProperties(){
		return BookedEntryCursorResultsModel.classProperties;
	}
}
export class DimensionDataModel extends Model<DimensionDataModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'entryNumber', type: 'number' },
		{ name: 'dimensionNumber', type: 'number' },
		{ name: 'dimensionKey', type: 'number' },
		{ name: 'isDistribution', type: 'boolean' }
	];
	[key: string]: any;
	
	public entryNumber?: number;
	public dimensionNumber?: number;
	public dimensionKey?: number;
	public isDistribution?: boolean;
    
	constructor(){
		super();
		this.entryNumber = undefined;
		this.dimensionNumber = undefined;
		this.dimensionKey = undefined;
		this.isDistribution = undefined;
		
	}
	getProperties(){
		return DimensionDataModel.classProperties;
	}
}
export class DimensionDataCursorResultsModel extends Model<DimensionDataCursorResultsModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'cursor', type: 'string' },
		{ name: 'items', type: 'DimensionDataModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new DimensionDataModel }, properties: () => { return DimensionDataModel.classProperties } }
	];
	[key: string]: any;
	
	public cursor: string;
	public items: DimensionDataModel[];
    
	constructor(){
		super();
		this.cursor = '';
		this.items = [];
		
	}
	getProperties(){
		return DimensionDataCursorResultsModel.classProperties;
	}
}
export class ErrorModel extends Model<ErrorModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'message', type: 'string' },
		{ name: 'errorCode', type: 'string' },
		{ name: 'property', type: 'string' }
	];
	[key: string]: any;
	
	public message: string;
	public errorCode: string;
	public property: string;
    
	constructor(){
		super();
		this.message = '';
		this.errorCode = '';
		this.property = '';
		
	}
	getProperties(){
		return ErrorModel.classProperties;
	}
}
export class MatchBookedEntriesModel extends Model<MatchBookedEntriesModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'entryIds', type: 'number[]', isArray: true }
	];
	[key: string]: any;
	
	public entryIds: number[];
    
	constructor(){
		super();
		this.entryIds = [];
		
	}
	getProperties(){
		return MatchBookedEntriesModel.classProperties;
	}
}
export class MatchedBookedEntriesPairModel extends Model<MatchedBookedEntriesPairModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'fromEntry', type: 'number' },
		{ name: 'fromEntryDate', type: 'Date' },
		{ name: 'fromEntryAmount', type: 'number' },
		{ name: 'fromEntryAmountDKK', type: 'number' },
		{ name: 'toEntry', type: 'number' },
		{ name: 'toEntryDate', type: 'Date' },
		{ name: 'toEntryAmount', type: 'number' },
		{ name: 'toEntryAmountDKK', type: 'number' }
	];
	[key: string]: any;
	
	public fromEntry?: number;
	public fromEntryDate?: Date;
	public fromEntryAmount?: number;
	public fromEntryAmountDKK?: number;
	public toEntry?: number;
	public toEntryDate?: Date;
	public toEntryAmount?: number;
	public toEntryAmountDKK?: number;
    
	constructor(){
		super();
		this.fromEntry = undefined;
		this.fromEntryDate = undefined;
		this.fromEntryAmount = undefined;
		this.fromEntryAmountDKK = undefined;
		this.toEntry = undefined;
		this.toEntryDate = undefined;
		this.toEntryAmount = undefined;
		this.toEntryAmountDKK = undefined;
		
	}
	getProperties(){
		return MatchedBookedEntriesPairModel.classProperties;
	}
}
export class MatchedBookedEntriesPairCursorResultsModel extends Model<MatchedBookedEntriesPairCursorResultsModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'cursor', type: 'string' },
		{ name: 'items', type: 'MatchedBookedEntriesPairModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new MatchedBookedEntriesPairModel }, properties: () => { return MatchedBookedEntriesPairModel.classProperties } }
	];
	[key: string]: any;
	
	public cursor: string;
	public items: MatchedBookedEntriesPairModel[];
    
	constructor(){
		super();
		this.cursor = '';
		this.items = [];
		
	}
	getProperties(){
		return MatchedBookedEntriesPairCursorResultsModel.classProperties;
	}
}
export class ProblemDetailsModel extends Model<ProblemDetailsModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'type', type: 'string' },
		{ name: 'title', type: 'string' },
		{ name: 'status', type: 'number' },
		{ name: 'detail', type: 'string' },
		{ name: 'instance', type: 'string' },
		{ name: 'errors', type: 'ErrorModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ErrorModel }, properties: () => { return ErrorModel.classProperties } },
		{ name: 'traceId', type: 'string' },
		{ name: 'errorCode', type: 'string' },
		{ name: 'traceTimeUtc', type: 'string' }
	];
	[key: string]: any;
	
	public type: string;
	public title: string;
	public status?: number;
	public detail: string;
	public instance: string;
	public errors: ErrorModel[];
	public traceId: string;
	public errorCode: string;
	public traceTimeUtc: string;
    
	constructor(){
		super();
		this.type = '';
		this.title = '';
		this.status = undefined;
		this.detail = '';
		this.instance = '';
		this.errors = [];
		this.traceId = '';
		this.errorCode = '';
		this.traceTimeUtc = '';
		
	}
	getProperties(){
		return ProblemDetailsModel.classProperties;
	}
}

export enum EntryTypeNames{
	_0 = 0,
	_1 = 1,
	_2 = 2,
	_3 = 3,
	_4 = 4,
	_5 = 5,
	_6 = 6,
	_7 = 7,
	_8 = 8,
	_9 = 9,
	_10 = 10
}
export namespace EntryTypeNames {
	export function getKeys(): Map<EntryTypeNames, string> {
		return new Map([[0, '_0'], [1, '_1'], [2, '_2'], [3, '_3'], [4, '_4'], [5, '_5'], [6, '_6'], [7, '_7'], [8, '_8'], [9, '_9'], [10, '_10']]);
	}
}
